import type { SectionState } from "../shared/dto";

// Pavel 2026-08-05 (F52): step 3 of know-how lost its checkbox in U1a
// (a2975f962a), so "Odeslat k tréninku" was either armed without an explicit
// confirmation or dead with nothing to click. The close gate is one pure
// decision so both surfaces and the guard test read the SAME truth:
// the team prepares the sources, the client ticks the box, only then does the
// confirmed send open. Every disabled state names its reason - a disabled
// button with no explanation is what blocked the client.
export interface KnowhowCloseGateInput {
  hasDrive: boolean;
  hasUrls: boolean;
  state: SectionState;
  confirmed: boolean;
  submitting: boolean;
}

export interface KnowhowCloseGate {
  /** The confirmation checkbox can be ticked (sources are ready and the step is open). */
  canConfirm: boolean;
  /** "Odeslat k tréninku" opens the confirmation dialog. */
  canSubmit: boolean;
  /** Locale key explaining why the client cannot act yet, null when it is their turn. */
  blockReasonKey: "knowhow.guard" | "knowhow.guardStep" | null;
}

export function knowhowCloseGate(input: KnowhowCloseGateInput): KnowhowCloseGate {
  const sourcesReady = input.hasDrive && input.hasUrls;
  const stepOpen = input.state === "next";
  const canConfirm = sourcesReady && stepOpen && !input.submitting;
  return {
    canConfirm,
    canSubmit: canConfirm && input.confirmed,
    // Sources missing wins: it is the first thing the team has to deliver.
    blockReasonKey: !sourcesReady ? "knowhow.guard" : !stepOpen ? "knowhow.guardStep" : null
  };
}
